export default "__VITE_ASSET__1d1b8d42__"